import { changeUrlNoHistory } from '../../utils/change-url';
import { isLargeScreen } from '../../utils/mediaquery-utils';
import { trackComscore, trackPhotoGallery } from '../../utils/analytics';
import { getLocation, getUrlHash } from '../../utils/build-urls';

const config = require('config');

const { loadedClass } = config.lazyLoadingContents;

let currentIntersectedElementId;
let previousIntersectedElementId;
const urlHash = getUrlHash();
const intersectedElementIds = urlHash ? [urlHash] : [];

const viewportElements = document.querySelectorAll('.j-gallery-item');
const localNav = document.querySelector('.j-local-nav');
const primaryTag = document.querySelector('.j-primary-tag');
const sectionNav = document.querySelector('.j-section-nav-wrapper');
const DATA_STATE_LOCAL_SECTION = sectionNav && localNav ? 'hasLocalSection' : null;
const DATA_STATE_LOCAL_PRIMARY = primaryTag && localNav ? 'hasLocalPrimary' : null;
const DATA_STATE_LOCAL_ONLY = !primaryTag && !sectionNav && localNav ? 'hasLocalOnly' : null;

const navState = DATA_STATE_LOCAL_SECTION || DATA_STATE_LOCAL_PRIMARY || DATA_STATE_LOCAL_ONLY;

const paginationOptions = {
  threshold: [0.7, 0.8, 0.9],
  rootMargin: '0px',
};

/**
 * Filter intersecting element
 * @param {*} nodes list of nodes
 */
// const filterIntersectingElement = nodes => nodes.find(node => node.isIntersecting);

/**
 * Change URL page number
 * and tracking Gallery
 */
const changePageNumber = () => {
  if (currentIntersectedElementId) {
    // Comscore tracking
    if (!intersectedElementIds.includes(currentIntersectedElementId)) {
      intersectedElementIds.push(currentIntersectedElementId);
      trackComscore();
    }

    const location = getLocation().withPathName;
    if (currentIntersectedElementId === '01') {
      if (Number(previousIntersectedElementId) > Number(currentIntersectedElementId)) {
        changeUrlNoHistory(`${location}#00`);
        trackPhotoGallery('#00');
      } else {
        changeUrlNoHistory(location);
      }
    } else {
      changeUrlNoHistory(`${location}#${currentIntersectedElementId}`);
      trackPhotoGallery(`#${currentIntersectedElementId}`);
    }
  }
};

/**
 * Initialize Gallery Scrolling Tracking
 */
export const init = () => {
  // do not externalize
  if (viewportElements.length) {
    const galleryScrollingEvents = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        previousIntersectedElementId = currentIntersectedElementId || previousIntersectedElementId;
        if (entry.isIntersecting) {
          if (entry.target.id !== currentIntersectedElementId) {
            currentIntersectedElementId = entry.target.id;
            changePageNumber();
          }
        } else {
          currentIntersectedElementId = undefined;
        }
      });
    }, paginationOptions);

    viewportElements.forEach((current) => {
      // Adding spacing on gallery item only for desktop according to the presented menus
      if (isLargeScreen()) {
        current.setAttribute('data-state', navState);
      }
      galleryScrollingEvents.observe(current);
    });

    console.info('Init gallery tracking.');
  }
};
